'use client'

import { TRoomsSearchParams } from '@/entities/room'
import { cn, StickyContainer } from '@/shared/lib'
import { InnerLayout, OuterLayout } from '@/shared/ui'
import { KeywordSearchBar } from '@/widgets/keyword-search-bar'

import { AirbridgeEventSender } from '../../lib/airbridge-event-sender'
import { useKeywordSearchParams } from '../../lib/keyword-search-params'
import { useStickyWhenHidden } from '../../lib/sticky-when-hidden'
import { useRooms } from '../../model/rooms'
import { Filter } from '../filter'
import { RoomList } from '../room-list/index.pc'
import { ScrollTopButton } from '../scroll-top-button'

type Props = {
  filters: TRoomsSearchParams
}

export const KeywordSearchPage = ({ filters }: Props) => {
  const { isPageReloading } = useKeywordSearchParams()

  const {
    rooms,
    roomCount,
    ref: sentinelRef,
    airbridgeEvent,
  } = useRooms({ filters })

  const { elementRef, containerRef, isSticky } = useStickyWhenHidden({
    topOffset: -700,
  })

  return (
    <>
      <AirbridgeEventSender airbridgeEvent={airbridgeEvent} filters={filters} />
      <OuterLayout className={cn('mt-10 min-h-[calc(100vh-132px)]')}>
        <InnerLayout className="my-0 flex flex-row">
          <div
            ref={containerRef}
            className="w-[296px] shrink-0 rounded-tl-sm bg-white shadow-[0_1px_7px_0_rgba(0,0,0,0.15)]"
            style={{ zIndex: 'calc(var(--z-index-sticky) + 1)' }}
          >
            <div className={cn(isSticky && 'sticky top-0 h-dvh')}>
              <Filter
                ref={elementRef}
                isLoading={isPageReloading}
                stuck={isSticky}
              />
            </div>
          </div>

          <div className="w-[784px] rounded-tr-sm bg-white shadow-[0_1px_7px_0_rgba(0,0,0,0.15)]">
            <StickyContainer>
              <div className="rounded-tr-sm bg-white/80 p-10 backdrop-blur-sm">
                <KeywordSearchBar size="large" />
              </div>
            </StickyContainer>
            <RoomList
              isLoading={isPageReloading}
              rooms={rooms}
              roomCount={roomCount}
              sentinelRef={sentinelRef}
            />
          </div>
          <ScrollTopButton className="fixed right-6 bottom-6" />
        </InnerLayout>
      </OuterLayout>
    </>
  )
}
